import { rightArrow } from 'icons/rightArrowExtended';
import { rocket } from 'icons/rocket';
import './launchScreen.scss';

export const LaunchScreenTemplate = (model) => {
	const { queryTitle, queryPlaceholder, previewHeader, goBack, themeColor, lastMessage, lastMessageDate } = model;

	/* html */
	const query = `
		<div class="engt-launch-query">
			<span id="launchQueryTitle" class="engt-launch-query-text">${queryTitle}</span>
			<div class="engt-launch-query-input">
				<div id="engtLaunchInputError" class="engt-launch-input-error"></div>
				<input type="text" class="engt-tab-selectable" id="engtQueryInput" placeholder="${queryPlaceholder}" tabindex="0"/>
				<span class="engt-launch-query-send-btn">${rocket()}</span>
			</div>
		</div>
	`;

	/* html */
	const previewDetails = `
		<div class="engt-launch-preview engt-launch-preview-hidden" id="launchPreview">
			<span class="engt-launch-preview-header" id="launchPreviewHeader">
				${previewHeader}
			</span>
			
			<div class="engt-launch-preview-go">
				<div class="engt-launch-preview-message">
					<span class="engt-text" id="launchPreviewMessage">${lastMessage}</span>
					<span class="time" id="launchPreviewTime">${lastMessageDate}</span>
				</div>
				<div class="engt-msg-preview-wrap">
					<div 
					style="${themeColor ? `fill: ${themeColor};color: ${themeColor}; cursor: pointer` : ''}" 
					tabindex="0"
					onclick="ENGT_CHAT.showChatScreen()"
					onkeydown="ENGT_CHAT.onEnterPress()"
					class="engt-go-back-to-chat engt-tab-selectable"
					>
						<span id="goBackConversation">${goBack}</span>
						${rightArrow()}
					</div>
					<unread-badge></unread-badge>
				</div>
			</div>
		</div>
	`;

	/* html */
	const html = `
		<div class="engt-launcher-details" id="engtLaunchScreenDetails" onscroll="ENGT_CHAT.onScrollToBottom(event, this)">
			${previewDetails}
			${query}
			<launch-cards></launch-cards>
			<scroll-to-bottom></scroll-to-bottom>
		</div>
		<powered-by></powered-by>
    `;

	return html;
};
